import React, { useEffect, useState, } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import styles from './css/user.module.css';
import apiurl from '../Api';
import Swal from 'sweetalert2';
import Select from 'react-select';
import $ from 'jquery';
import "flatpickr/dist/themes/light.css";
import DataTable from "react-data-table-component";
function Vendor_Dash() {
  const navigate = useNavigate();

  const [jobDescription, setJobDescription] = useState("");
  const [inputValue, setInput] = useState("");
  const [requirement, setRequirement] = useState(null);

  const { aid } = useParams();

  const [staff, setStaff] = useState([]);
  const [total, setTotal] = useState(0);

  const [selectedGender, setGender] = useState(null);
  const [selectedCost, setCost] = useState(null);
  const [education, setEducation] = useState(null);
  const [selectPlace, setPlacement] = useState(null);

  const [client, setClient] = useState([]);
  const [team, setTeam] = useState([]);

  const [remark, setText] = useState("");
  const [loading, setTableLoading] = useState(true);

  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedTeam, setSelectedTeam] = useState(null);


  const [designation, setDesignation] = useState(null);

  const [metaData, setMetaData] = useState({
    appname: '',
    edit: false,
    del: false,
    add: false,
    view: false,
    typess: '',
    icon: '',
    defaultShow: 10
  });

   const [dashboard, setDashboard] = useState({
    first: '0',
    second: '0',
    third: '0',
    four: '0',
    five: '0',
    six: '',
    seven: '0',
    clientName:''
  });

  const [selected, setSelected] = useState({
    profile: null,
    location: null,
    branch: null,
  });

  const [options, setOptions] = useState({
    profile: [],
    location: [],
    branch: [],
  });

  const selects = [
    {
      key: "profile",
      label: "Select Designation",
      placeholder: "Enter POST",
    },
    {
      key: "location",
      label: "Select Location",
      placeholder: "Enter Location",
    },
    {
      key: "branch",
      label: "Select Branch",
      placeholder: "Enter Branch",
    },
  ];


  const fetchData = async () => {
    const response = await axios.get(apiurl + 'requirement.php?subdomain=react'); // Replace with your API endpoint
    setStaff(response.data.staff);
    setClient(response.data.client);
    setTeam(response.data.team);

    setOptions({ profile: response.data.post, location: response.data.location, branch: response.data.branch, });

    setMetaData({
      appname: response.data.appname,
      edit: response.data.edit,
      del: response.data.del,
      add: response.data.add,
      view: response.data.view,
      typess: response.data.typess,
      icon: response.data.icon,
      defaultShow: response.data.defaultShow
    });
    setTotal(response.data.total);
    setTableLoading(false);
  };

  const filterBtn = async (sel = selected) => {
    const data = {
      location: sel.location?.value,
      profiles: sel.profile?.value,
      branchh: sel.branch?.value,
      aid: aid,
      subdomain: 'react'
    };

    $("#showLoader").removeClass('d-none').addClass('d-flex');
    const response = await axios.get(apiurl + 'requirement.php', {
      params: data
    });

    setStaff(response.data.staff);
    setTotal(response.data.total);
    console.log(response.data.messagess);


    $("#showLoader").removeClass('d-flex').addClass('d-none');
  };


  useEffect(() => {
    fetchData();
    $('#modalclose').on('click', function () {
      $("#hidden").val("");
      $("#reset").click();
    });

  }, []);


  const setLoading = (show) => {
    if (show) {
      $("#showLoader").removeClass("d-none").addClass("d-flex");
    } else {
      $("#showLoader").removeClass("d-flex").addClass("d-none");
    }
  };


    const EditData = async (edit, sss) => {
    if (edit) {
      $("#showLoader").removeClass('d-none').addClass('d-flex');
      setJobDescription("");
      try {
        const response = await axios.get(apiurl + 'requirement.php?edit=' + edit);
        if (response.data.status == true) {
            setRequirement(response.data.data[0]);

            $("#tera_modal3").click();

          $("#showLoader").removeClass('d-flex').addClass('d-none');
        } else {
          // modal can't show
          $("#showLoader").removeClass('d-flex').addClass('d-none');
          alert("data not found");
        }

      }
      catch (error) {
        console.error('Error deleting category:', error);
      }

    }

  };

  const updateDetails = async (idd, val) => {
    const response = await axios.get(apiurl + 'requirement.php?com=' + idd + "&value=" + val);
    if (val == '1' || val == '2' || val == '3' || val == '4') {

      setInput(response.data.value || "");
      $("#showornot").show();
      switch (val) {
        case "1":
          setText("BD Comment");
          break;
        case "2":
          setText("SM REMARK");
          break;
        case "3":
          setText("SH REMARK");
          break;
        case "4":
          setText("Job Description");
          $("#showornot").hide();
          break;
      }

      $("#tera_modal").click();
      $("#allModal #hiddens").val(response.data.hidden);
      $("#allModal #type").val(val);

    }
    else {
      $("#tera_modal2").click();
      $("#SourceForm #hiddens").val(response.data.hidden);
      $("#SourceForm #type").val(val);
      $("#SourceForm #clients").val(response.data.client);
      $("#SourceForm #locations").val(response.data.location);
      $("#SourceForm #posts").val(response.data.designation);

    }


  };


  const columns = [
     { name: "Request Time", selector: (row) => row.date, sortable: true, wrap: true },
    { name: "Require ID", selector: (row) => row.rid, sortable: true, wrap: true },
    
    { name: "Client Name", selector: (row) => row.name, sortable: true, wrap: true },
    { name: "REC Name", selector: (row) => row.recname, sortable: true, wrap: true },

    { name: "Contract", selector: (row) => row.contract, sortable: true, wrap: true },
    { name: "Placement_type", selector: (row) => row.pType, sortable: true, wrap: true },
    { name: "Anchor", selector: (row) => row.anchor, sortable: true, wrap: true },
    { name: "Branch", selector: (row) => row.branch, sortable: true, wrap: true },
    { name: "NO. of Position", selector: (row) => row.position, sortable: true, wrap: true },
    { name: "Designation", selector: (row) => row.designation, sortable: true, wrap: true },

    { name: "Location", selector: (row) => row.location, sortable: true, wrap: true },
     
  ];

   if (
    metaData.typess?.toUpperCase() === "ADMIN" ||
    metaData.del === 1 ||
    metaData.view === 1 ||
    metaData.add === 1 ||
    metaData.edit === 1
  ) {
    columns.push({
      name: "Action",
      cell: (row) => (
        <div className="btns">
          <a
            href="javascript:void(0);"
            aria-label="anchor"
            style={{ marginTop: "-3px", display: "inline-block" }}
            className="text-muted"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="ri-more-2-line fs-17"></i>
          </a>

          <ul className="dropdown-menu">
            {(metaData.typess?.toUpperCase() === "ADMIN" || metaData.view === 1) && (
              <li className="mb-0">
                <button
                  className="dropdown-item"
                  onClick={() => EditData(row.hidden, "2")}
                >
                  <i className="ri-eye-line"></i> Requirement Detail
                </button>
              </li>
            )}
 <li className="mb-0">
              <button
                className="dropdown-item"
                onClick={() => updateDetails(row.hidden, "2")}
              >
                POA
              </button>
            </li>
            <li className="mb-0">
              <button
                className="dropdown-item"
                onClick={() => updateDetails(row.hidden, "3")}
              >
                LINE REPORT
              </button>
            </li>
            <li className="mb-0">
              <button
                className="dropdown-item"
                onClick={() => updateDetails(row.hidden, "4")}
              >
                DASHBOARD
              </button>
            </li>
            <li className="mb-0">
              <button
                className="dropdown-item"
                onClick={() => updateDetails(row.hidden, "5")}
              >
                UPLOAD DATA FILE
              </button>
            </li>
          </ul>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    });
  }


  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(staff);

  useEffect(() => {
    document.title = "Vendor Requirement Dashboard | MERAQUI";
    if (!searchText) {
      setFilteredData(staff);
    } else {
      setTableLoading(true);
      const lower = searchText.toLowerCase();
      setFilteredData(
        staff.filter(
          (item) =>
            item.rid?.toString().toLowerCase().includes(lower) ||
            item.recname?.toLowerCase().includes(lower) ||
            item.name?.toLowerCase().includes(lower) ||
            item.branch?.toLowerCase().includes(lower) ||
            item.contactName?.toLowerCase().includes(lower) ||
            item.location?.toLowerCase().includes(lower) ||
            item.designation?.toLowerCase().includes(lower) ||
            item.jobTitle?.toLowerCase().includes(lower) ||
            item.date?.toLowerCase().includes(lower)
        )
      );
setTimeout(() => {
    setTableLoading(false);
  }, 300); // 300ms fake delay, adjust as needed
  }
  }, [searchText, staff]);


    const SourceForm = async (e) => {
      e.preventDefault();
      try {
        const formData = new FormData($("#SourceForm")[0]);
        formData.append("aid", aid);
        setLoading(true);
        const response = await axios.post(apiurl + "vendor_list.php", formData);
        if (response.data.status == true) {
          
          setLoading(false);
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 2000
          }).then(() => {
            $("#okayClose2").click();
            $("#SourceForm .btn-danger").click();
          });
        }
        else {
          setLoading(false);
          Swal.fire({
            position: "top-center",
            icon: "error",
            title: response.data.message,
            showConfirmButton: false,
            timer: 2000
          });
        }
      } catch (error) {
        console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
      }
      finally {
        setLoading(false);
      }
    };
  return (
    <>
      {/* modal all */}
      <button data-bs-toggle="modal" id="tera_modal" data-bs-target="#allModal" type="button" style={{ display: 'none' }}></button>
      <button data-bs-toggle="modal" id="tera_modal2" data-bs-target="#sourceModal" type="button" style={{ display: 'none' }}></button>
      <button data-bs-toggle="modal" id="tera_modal3" data-bs-target="#tableModal" type="button" style={{ display: 'none' }}></button>

      <div className="modal effect-rotate-left fade" id="allModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="allModal" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="allModal">Client : {dashboard.clientName}</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" id="okayClose" aria-label="Close"></button>
            </div>
             <div className="modal-body pb-0">

            <div class="row gy-md-0 gy-3" id='all'>
                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                    <div class="d-flex align-items-top">
                        <div class="me-3">
                            <span class="avatar bg-outline-primary"> <i class="bi bi-projector-fill fs-30"></i> </span>
                        </div>
                        <div>
                            <span class="d-block mb-1 text-muted">Provided Data</span>
                            <h6 class="fw-semibold mb-0">{dashboard.first}</h6>
                        </div>
                    </div>
                </div>
                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                    <div class="d-flex align-items-top">
                        <div class="me-3">
                             <span class="avatar bg-outline-primary"> <i class="bi bi-disc-fill fs-30"></i> </span>
                        </div>
                        <div>
                            <span class="d-block mb-1 text-muted">Actual Data</span>
                            <h6 class="fw-semibold mb-0">{dashboard.second}</h6>
                        </div>
                    </div>
                </div>
                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                    <div class="d-flex align-items-top">
                        <div class="me-3">
                             <span class="avatar bg-outline-primary"> <i class="bi bi-calendar2-week fs-30"></i> </span>
                        </div>
                        <div>
                            <span class="d-block mb-1 text-muted">Line Up</span>
                            <h6 class="fw-semibold mb-0">{dashboard.third}</h6>
                        </div>
                    </div>
                </div>

                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                    <div class="d-flex align-items-top">
                        <div class="me-3">
                            <span class="avatar bg-outline-primary"> <i class="bi bi-check2-square fs-30"></i> </span>
                        </div>
                        <div>
                            <span class="d-block mb-1 text-muted">Interview Selected</span>
                            <h6 class="fw-semibold mb-0">{dashboard.four}</h6>
                        </div>
                    </div>
                </div>

                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                    <div class="d-flex align-items-top">
                        <div class="me-3">
                            <span class="avatar bg-outline-primary"> <i class="bi bi-joystick fs-30"></i> </span>
                        </div>
                        <div>
                            <span class="d-block mb-1 text-muted">Joined</span>
                            <h6 class="fw-semibold mb-0">{dashboard.five}</h6>
                        </div>
                    </div>
                </div>

                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                    <div class="d-flex align-items-top">
                        <div class="me-3">
                            <span class="avatar bg-outline-primary"> <i class="bi bi-envelope-paper fs-30"></i> </span>
                        </div>
                        <div>
                            <span class="d-block mb-1 text-muted">Offer Letter Released</span>
                            <h6 class="fw-semibold mb-0">{dashboard.six}</h6>
                        </div>
                    </div>
                </div>

                 <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                    <div class="d-flex align-items-top">
                        <div class="me-3">
                            <span class="avatar bg-outline-primary"> <i class="ri-remote-control-fill fs-30"></i> </span>
                        </div>
                        <div>
                            <span class="d-block mb-1 text-muted">Payrolled</span>
                            <h6 class="fw-semibold mb-0">{dashboard.seven}</h6>
                        </div>
                    </div>
                </div>

            </div>



              </div>
          </div>
        </div>
      </div>

      <div className="modal effect-super-scaled fade" id="tableModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="tableModal" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-body">

              <div className='d-flex'>


                <table className="table table-bordered">
                  <tbody>
                    {requirement && [
                      ["RecID", requirement.rid, "Age To", requirement.ageTo],
                      ["Branch", requirement.branchh, "CTC To", requirement.ctcTo],
                      ["Gender", requirement.gender.toUpperCase(), "RecName", requirement.recname],
                      ["Age From", requirement.ageFrom, "CTC From", requirement.ctcFrom],
                      ["EXP From", requirement.expFrom, "Anchor", requirement.anchor],
                      ["Location", requirement.location, "From Date", requirement.fromDate],
                      ["Client Name", requirement.cidd, "Commercials", requirement.commercials],
                      ["Designation", requirement.posts, "Contact Name", requirement.contactName],
                      ["Education Type", requirement.education, "Placement Type", requirement.placementType],
                      ["EXP To", requirement.expTo, "Requirement Status", requirement.statuses],
                      ["To Date", requirement.toDate, "Contract", requirement.contract],
                      ["KeyWords", requirement.keywords, "Job Title", requirement.jobTitle],
                      ["Cost Center", requirement.costCenter, "NetTake to CTC", requirement.ctcTo],
                      ["No Of Position", requirement.noOfPosition, "NetTake from CTC", requirement.ctcFrom],
                      ["Requirement Create Time", requirement.datestimes]
                    ].map((row, idx) => (
                      <tr key={idx}>
                        <th style={{ backgroundColor: "#fafafa" }}>{row[0]}</th>
                        <td>{row[1]}</td>
                        <th style={{ backgroundColor: "#fafafa" }}>{row[2]}</th>
                        <td>{row[3]}</td>
                      </tr>
                    ))}

                  </tbody>
                </table>


                <img className="order-1" src={process.env.PUBLIC_URL + "/admin_assets/images/media/file.svg"} style={{ width: '24%' }} />


              </div>


            </div>
            <div className='modal-footer' style={{ padding: '0px' }}>
              <button type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal" id="okayClose" aria-label="Close">Close</button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal effect-flip-vertical fade" id="sourceModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="sourceModal" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="sourceModal">UPLOAD DATA FILE</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" id="okayClose2" aria-label="Close"></button>
            </div>

            <div className='d-flex'>
              <form id="SourceForm" className="order-1" onSubmit={SourceForm}>

                <div className="modal-body">

                  <div className="row g-3">

                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <label htmlFor="branch" className="form-label">CLIENT NAME</label>
                      <input type="text" id='clients' name='clients' className="form-control" placeholder="Client" readOnly />
                    </div>

                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <label htmlFor="contract" className="form-label">LOCATION</label>
                      <input type="text" id='locations' className="form-control" placeholder="location" readOnly />
                    </div>

                    <div className="col-xl-7 col-lg-7 col-md-6">
                      <label htmlFor="contactName" className="form-label">DESIGNATION</label>
                      <input type="text" id='posts' className="form-control" placeholder="Designation" readOnly />
                    </div>
                    
                    <div className="col-lg-2" id='resumelabel'>
                     {/* Category Input */}
                     <p className="form-label">DATA FILE</p>
                      <input id="dataFile" accept=".csv" name="dataFile" className="form-control" autoComplete='off' type='file' defaultValue="" style={{display:'none'}}/>
                      <label htmlFor="dataFile"  className='form-label' style={{width:'60px',height:'60px',textAlign:'center',alignContent:'center',border:'2px solid',borderColor:'rgb(var(--primary-rgb))!important'}}>
                           <span style={{fontSize:'35px',marginTop:'-9px',display:'inline-block'}}>+</span>
                      </label>
                   </div>
                 
                    <div className="col-lg-12" style={{ textAlign: 'right' }}>
                      <input type="hidden" name="hiddens" id="hiddens" />
                      <input type="hidden" name="types" id="type" />
                      <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{ marginRight: '20px', display: 'none' }} />
                    </div>
                    <div className='col-lg-12'>
                      <button className="btn btn-primary me-4" type='button' onClick={()=>{window.location=`${process.env.REACT_APP_EXPORT_URL || "/"}demo/SampleTamplate.xlsx`;}}>SAMPLE DOWNLOAD</button>
                      <button type="submit" className="btn btn-primary">UPLOAD</button>
                    </div>
                  </div>

                </div>

              </form>

              <img className="order-2" src={process.env.PUBLIC_URL + "/admin_assets/images/media/media-699.svg"} style={{ width: '35%', height: '100%' }} />
            </div>

          </div>
        </div>
      </div>

      <div className="main-content app-content">

        <div className="container-fluid">

          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12  mt-3 mb-4">
              <div className="card custom-card" style={{ marginBottom: '0px' }}>
                <div className="card-body">

                  <div className="row gy-3">
                    {selects.map(({ key, label, placeholder }) => (
                      <div className="col-xl-4" key={key}>
                        <label className="form-label">{label}</label>
                        <Select
                          options={options[key]}
                          value={selected[key]}
                          onChange={(val) => {
                            setSelected((prev) => ({ ...prev, [key]: val }));
                            filterBtn({ ...selected, [key]: val });
                          }}
                          placeholder={placeholder}
                          isSearchable
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          
          </div>


          <div className="row">
            <div className="col-xxl-12 col-xl-12 ">
              <div className="card custom-card">
                <div className="card-header justify-content-between" style={{ paddingBottom: '15px', alignItems: 'normal' }}>
                  <div>
                    <h6 className="fs-16">{metaData.appname}</h6>
                  </div>
                  <div className="d-flex mt-sm-0 mt-2 align-items-center" style={{width:'35%'}}>

                    <div className="input-group" >
                      <input type="search" className="form-control" placeholder="Search Users" id="search-member" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                    </div>
              
                  </div>

                </div>
                <div className="card-body" style={{ padding: '10px' }}>
                  <div className={styles.category_table}>

                    <DataTable
                      columns={columns}
                      data={filteredData}
                      progressPending={loading}
                      pagination
                      paginationPerPage={metaData.defaultShow}
                      paginationRowsPerPageOptions={[50, 100, 200, 300]}
                      highlightOnHover
                      persistTableHead
                      striped
                      responsive
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Vendor_Dash;
